import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import Link from 'components/_new/typography/Link/Link'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './ForgotPasswordButton.scss'


const ForgotPasswordButton = ({ type = 'button', onClick }) =>
  type === 'link' ? (
    <Link to={links.remindPassword} color="black" withUnderline={false} onClick={onClick}>
      <Text className={s.text} message={messages.title} tag="span" />
    </Link>
  ) : (
    <Text className={s.text} message={messages.title} tag="button" onClick={onClick} />
  )

ForgotPasswordButton.propTypes = {
  onClick: PropTypes.func,
}


export default React.memo(ForgotPasswordButton)
